import { render, staticRenderFns } from "./ListClasses.vue?vue&type=template&id=eb9390d4&"
import script from "./ListClasses.vue?vue&type=script&lang=js&"
export * from "./ListClasses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports